import React from 'react';

const ShiftsTab = ({
  shifts,
  loading,
  openCreateShiftModal,
  openEditShiftModal,
  handleDeleteShift
}) => {
  return (
    <div className="shifts-view">
      <div className="view-header">
        <button className="btn btn-primary" onClick={openCreateShiftModal}>
          + Add Shift
        </button>
      </div>
      <div className="items-grid">
        {shifts.map(shift => (
          <div key={shift.shift_id} className="item-card" style={{ borderLeft: `4px solid ${shift.color}` }}>
            <div className="item-header">
              <h3>{shift.name}</h3>
            </div>
            <div className="item-details">
              <p><strong>Time:</strong> {shift.start_time} - {shift.end_time}</p>
              <p><strong>Days:</strong> {shift.days_of_week?.map(d => d.substring(0, 3)).join(', ')}</p>
            </div>
            <div className="item-actions">
              <button className="btn btn-sm" onClick={() => openEditShiftModal(shift)}>Edit</button>
              <button className="btn btn-sm btn-danger" onClick={() => handleDeleteShift(shift)}>Deactivate</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ShiftsTab;
